export class SocketSession {
  public socketId: string;
  public warehouseId: number;
  public userId: number;
}
